angular.module('ui-ng-session-timer', ['ui-ng-delegate', 'ui-ng-modal', 'ui-ng-notification']);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/core.js